import { Navigate } from 'react-router-dom';
import useUserStore from './UserStore';

const ProtectedRoute = ({ children, requiredFunctionalArea }) => {
  const isAuthorized = useUserStore((state) => state.isAuthorized);
  const functionalAreas = useUserStore(
    (state) => state.user?.authResponse?.profile?.functional_areas
  );

  console.log('ProtectedRoute - isAuthorized:', isAuthorized);

  if (!isAuthorized) {
    return <Navigate to="/login" replace />;
  }

  if (requiredFunctionalArea) {
    const hasFunctionalArea =
      Array.isArray(functionalAreas) &&
      functionalAreas.some(
        (area) =>
          String(area).toLowerCase() ===
          String(requiredFunctionalArea).toLowerCase()
      );

    if (!hasFunctionalArea) {
      return <Navigate to="/" replace />;
    }
  }
  
  return children;
};

export default ProtectedRoute;